var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Loading", { attrs: { active: _vm.loading, "is-full-page": true } }),
      _c(
        "div",
        { staticClass: "pa-3", attrs: { align: "center", justify: "center" } },
        [
          _c(
            "v-card",
            { staticClass: "mb-3", attrs: { align: "left", justify: "left" } },
            [
              _c(
                "v-card-text",
                { staticClass: "pa-3 font-weight-light white black--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "primary--text lighten-2 pa-2" },
                    [_vm._v(" mdi-alert-circle-outline ")]
                  ),
                  _vm._v(" Administração > Falha de Retornos ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            {
              staticClass: "pa-3 mb-4",
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.aplicarFiltros.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "v-row",
                { staticClass: "pa-3 d-flex align-center" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex flex-row pa-0",
                      attrs: { cols: "6", xs: "8", sm: "8", md: "6", lg: "6" }
                    },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.apresentantesOptions,
                          "item-text": "name",
                          "item-value": "value",
                          label: "Filtrar por Apresentante",
                          multiple: "",
                          chips: "",
                          "deletable-chips": "",
                          clearable: "",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          disabled: _vm.loading,
                          "data-cy": "filtroApresentante"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function({ item, index }) {
                              return [
                                index === 0
                                  ? _c(
                                      "v-chip",
                                      {
                                        attrs: {
                                          small: "",
                                          color: "primary",
                                          "text-color": "white"
                                        }
                                      },
                                      [
                                        _vm._v(" " + _vm._s(item.name) + " "),
                                        _vm.filtroApresentante.length > 1
                                          ? _c(
                                              "span",
                                              { staticClass: "ml-1" },
                                              [
                                                _vm._v(
                                                  " (+" +
                                                    _vm._s(
                                                      _vm.filtroApresentante
                                                        .length - 1
                                                    ) +
                                                    ") "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.filtroApresentante,
                          callback: function($$v) {
                            _vm.filtroApresentante = $$v
                          },
                          expression: "filtroApresentante"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "d-flex justify-end align-center pa-0" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            color: "primary",
                            disabled: _vm.loading,
                            "data-cy": "btnFiltrar"
                          },
                          on: { click: _vm.aplicarFiltros }
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-magnify")
                          ]),
                          _vm._v(" Filtrar ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            outlined: "",
                            color: "secondary",
                            disabled: _vm.loading,
                            "data-cy": "btnLimpar"
                          },
                          on: { click: _vm.limparFiltros }
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-filter-remove")
                          ]),
                          _vm._v(" Limpar ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "pa-3" },
            [
              _c(
                "v-card-actions",
                { staticClass: "pb-0" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "warning",
                        disabled:
                          _vm.itensSelecionados.length === 0 || _vm.loading,
                        "data-cy": "btnIgnorarLote"
                      },
                      on: { click: _vm.abrirConfirmacaoIgnorarLote }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-eye-off")
                      ]),
                      _vm._v(
                        " Ignorar Retornos (" +
                          _vm._s(_vm.itensSelecionados.length) +
                          ") "
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.falhasRetorno,
                  loading: _vm.loading,
                  "footer-props": {
                    itemsPerPageOptions: [10, 20, 50, 100],
                    itemsPerPageText: "Itens por página:"
                  },
                  "item-key": "id",
                  "server-items-length": _vm.totalItems,
                  page: _vm.currentPage,
                  "items-per-page": _vm.itemsPerPage,
                  "show-select": ""
                },
                on: {
                  "update:page": [
                    function($event) {
                      _vm.currentPage = $event
                    },
                    _vm.carregarDados
                  ],
                  "update:itemsPerPage": function($event) {
                    _vm.itemsPerPage = $event
                  },
                  "update:items-per-page": [
                    function($event) {
                      _vm.itemsPerPage = $event
                    },
                    _vm.carregarDados
                  ]
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.dt_movimento`,
                      fn: function({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatarData(item.dt_movimento)) +
                              " "
                          )
                        ]
                      }
                    },
                    {
                      key: `item.dt_apontamento`,
                      fn: function({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatarData(item.dt_apontamento)) +
                              " "
                          )
                        ]
                      }
                    },
                    {
                      key: `item.titulo_dt_protocolo`,
                      fn: function({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatarData(item.titulo_dt_protocolo)
                              ) +
                              " "
                          )
                        ]
                      }
                    },
                    {
                      key: `item.acoes`,
                      fn: function({ item }) {
                        return [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  color: "info",
                                                  "data-cy": "btnCorrecao"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.abrirModalCorrecao(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-file-edit")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_c("span", [_vm._v("Correção")])]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.itensSelecionados,
                  callback: function($$v) {
                    _vm.itensSelecionados = $$v
                  },
                  expression: "itensSelecionados"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.modalEdicaoAtivo
        ? _c("ModalEdicaoFalhaRetorno", {
            attrs: {
              showModal: _vm.modalEdicaoAtivo,
              falhaRetorno: _vm.falhaRetornoSelecionada,
              aguardandoReprocessamento: _vm.aguardandoReprocessamento
            },
            on: {
              fecharModal: _vm.fecharModalEdicao,
              mostrarMensagem: _vm.mostrarMensagem,
              atualizarLista: _vm.carregarDados
            }
          })
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          attrs: {
            color: _vm.snackbarColor,
            timeout: "5000",
            top: "",
            right: ""
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { text: "" },
                        on: {
                          click: function($event) {
                            _vm.snackbar = false
                          }
                        }
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Fechar ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [_vm._v(" " + _vm._s(_vm.snackbarMessage) + " ")]
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.dialogConfirmacao,
            callback: function($$v) {
              _vm.dialogConfirmacao = $$v
            },
            expression: "dialogConfirmacao"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(" " + _vm._s(_vm.confirmacao.titulo) + " ")
              ]),
              _c("v-card-text", [
                _vm._v(" " + _vm._s(_vm.confirmacao.texto) + " ")
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: { click: _vm.confirmarAcao }
                    },
                    [_vm._v(" Confirmar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red darken-1", text: "" },
                      on: { click: _vm.cancelarConfirmacao }
                    },
                    [_vm._v(" Cancelar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.dialogConfirmacaoLote,
            callback: function($$v) {
              _vm.dialogConfirmacaoLote = $$v
            },
            expression: "dialogConfirmacaoLote"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "headline warning--text" },
                [
                  _c("v-icon", { attrs: { left: "", color: "warning" } }, [
                    _vm._v("mdi-alert")
                  ]),
                  _vm._v(" Ignorar Retornos em Lote ")
                ],
                1
              ),
              _c("v-card-text", { staticClass: "pt-4" }, [
                _c("p", { staticClass: "text-body-1" }, [
                  _vm._v(" Você está prestes a ignorar "),
                  _c("strong", [_vm._v(_vm._s(_vm.itensSelecionados.length))]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.itensSelecionados.length === 1
                          ? "retorno"
                          : "retornos"
                      ) +
                      ". "
                  )
                ]),
                _c("p", { staticClass: "text-body-2 mb-0" }, [
                  _vm._v(
                    " Esta ação não poderá ser desfeita. Deseja continuar? "
                  )
                ])
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey darken-1",
                        text: "",
                        disabled: _vm.loadingIgnorarLote
                      },
                      on: { click: _vm.cancelarConfirmacaoLote }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "warning",
                        loading: _vm.loadingIgnorarLote,
                        disabled: _vm.loadingIgnorarLote
                      },
                      on: { click: _vm.confirmarIgnorarLote }
                    },
                    [_vm._v(" Confirmar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }